import AppProviders from '@/app/providers/AppProviders'
import AppRouter from '@/app/router/AppRouter'
import { Toaster } from '@/clientWeb/components/ui/toaster'
import {
  NetworkErrorDialog,
  useNetworkStatus,
} from '@/clientWeb/components/ui/network-error-dialog'

function App() {
  const { showDialog, retry } = useNetworkStatus()

  return (
    <AppProviders>
      <AppRouter />
      <Toaster position="bottom-right" />
      <NetworkErrorDialog isOpen={showDialog} onRetry={retry} />
    </AppProviders>
  )
}

export default App
